export default class ScreenOrientationHelper {

    static RemoveOrientationChangeEventListener(callback: (() => void) | null): void {
        if (callback) {
            window.removeEventListener('orientationchange', callback);
        }
    }

    static AddOrientationChangeEventListener(callback: (() => void) | null): void {
        if (callback) {
            window.addEventListener('orientationchange', callback);
        }
    }

    static CurrentOrietnation(): string {
        return screen.orientation.type;
    }

    static LockPortrait() {
        void screen.orientation.lock('portrait');
    }

    static LockLandscape() {
        void screen.orientation.lock('landscape');
    }

    static Unlock() {
        void screen.orientation.unlock();
    }
}